import { render, staticRenderFns } from "./NoVideo.vue?vue&type=template&id=39ea81aa&"
import script from "./NoVideo.vue?vue&type=script&lang=js&"
export * from "./NoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports